import { render, staticRenderFns } from "./custom-dropdown-unit.vue?vue&type=template&id=0ddad112&"
import script from "./custom-dropdown-unit.vue?vue&type=script&lang=ts&"
export * from "./custom-dropdown-unit.vue?vue&type=script&lang=ts&"
import style0 from "./custom-dropdown-unit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports